<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas4bg.svg" />
    <p id="text01" class="textBase pageElement">
      Siguieron, entonces, los tres por el camino. Una mañana, se toparon con un
      enorme hormiguero. Los hermanos mayores buscaron ramas bien largas para
      romperlo. Querían ver a las hormigas corriendo asustadas, cargando sus
      huevitos.
    </p>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 18px;
  top: 48px;
}
#text01 {
  position: absolute;
  width: 555px;
  height: 423px;
  left: 41px;
  top: 71px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 4.mp4"],
    }
  }
}
</script>
